import callApi, { METHOD_TYPE } from '../utils/callApi'
import { SAMPLE } from '../mutations'

const state = {
  counter: 0,
  successMessage: '',
  errorMessage: '',
  initDisplay: 'not call API yet'
}

const mutations = {
  [SAMPLE.INIT_DATA](state, payload) {
    state.initDisplay = payload
  },
  [SAMPLE.INCREASE](state) {
    state.counter += 1
  },
  [SAMPLE.DECREASE](state) {
    state.counter -= 1
  },
  [SAMPLE.API_SUCCESS](state, payload) {
    state.successMessage = payload
  },
  [SAMPLE.API_FAILED](state, payload) {
    state.errorMessage = payload
  }
}

const actions = {
  getInitData({ commit }) {
    callApi('/api/init', METHOD_TYPE.GET)
    .then((response) => {
      commit(SAMPLE.INIT_DATA, response.body.result)
    })
  },
  increase({ commit }, counter) {
    commit(SAMPLE.INCREASE, counter)
  },
  decrease({ commit }, counter) {
    commit(SAMPLE.DECREASE, counter)
  },
  callSuccess({ commit }) {
    callApi('/api', METHOD_TYPE.GET)
    .then((response) => {
      commit(SAMPLE.API_SUCCESS, response.body.result)
    })
  },
  callFailed({ commit }) {
    callApi('/api/error', METHOD_TYPE.GET)
    .catch((error) => {
      commit(SAMPLE.API_FAILED, error.response.text)
    })
  }
}

export default {
  state,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/stores/sample.js